import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { CAMINHO_DAS_RETIDAS } from '@/features/email/navegacao';
import { MensagensRetidasPage } from '@/features/email/MensagensRetidasPage';

/**
 * Rota da fila de mensagens retidas.
 *
 * Exportada como **fábrica**, e não como objeto pronto, pelo mesmo motivo de
 * `features/tickets/routes.ts`, `features/admin/routes.ts` e
 * `features/clientes/routes.ts`: `createRoute` exige a rota pai, e o pai
 * (`appRoute`, com o `AppShell` e a guarda de sessão) mora em `app/router.tsx`,
 * que pertence a outro dono. Receber o pai por parâmetro deixa a integração ser
 * uma linha lá, sem que esta feature importe de dentro de `app/` — o que
 * fecharia um ciclo entre o roteador e a tela que ele monta.
 *
 * **Uma rota só, sem filha de detalhe.** A mensagem abre numa janela sobre a
 * lista, e não numa página própria: a decisão precisa do conteúdo, e a fila é
 * para ser drenada em sequência — navegar e voltar perderia a posição a cada
 * decisão. Dar endereço próprio a cada mensagem também criaria um link que, uma
 * hora depois de a decisão ser tomada, aponta para 404.
 *
 * Integração esperada em `app/router.tsx`:
 *
 * ```ts
 * const retidasRoute = criarRotasDeMensagensRetidas(appRoute);
 * appRoute.addChildren([indexRoute, retidasRoute]);
 * ```
 */
export function criarRotasDeMensagensRetidas<TRotaPai extends AnyRoute>(rotaPai: TRotaPai) {
  return createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_DAS_RETIDAS,
    component: MensagensRetidasPage,
  });
}

export { CAMINHO_DAS_RETIDAS };
